// Insurance Portal Route Configuration
import { lazy } from 'react';

const InsuranceOverview = lazy(
  () => import('../../portals/insurance/pages/overview/InsuranceOverview')
);

/**
 * Insurance Portal Routes
 *
 * First release: an admin-only scaffold (layout, navigation, one empty page).
 * Access is decided by canAccessPortal('insurance') in usePermissions, which
 * admits admins and super-admins only, via InsurancePortalRoute
 * (see routing/guards/PortalRoute.js).
 */
export const insuranceRoutes = {
  path: '/insurance',
  name: 'Insurance Portal',
  description: 'Insurance workspace (admin-only scaffold)',
  requiredRoles: [],
  requiredPermissions: [],
  children: [
    {
      index: true,
      component: InsuranceOverview,
      name: 'Overview',
      description: 'Insurance portal overview',
      requiredPermissions: [],
      meta: {
        title: 'Insurance',
        breadcrumb: 'Overview',
        icon: 'dashboard',
      },
    },
  ],
};

export default insuranceRoutes;
